export default __webpack_public_path__ + "static/media/facebook-charitable-giving.6713dffa.png";